import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { sidebarReducer, notificationReducer, modalDialogReducer, addCustomerModalReducer } from '@css-xp/base';

const Reducer = combineReducers({
  sidebar: sidebarReducer,
  notification: notificationReducer,
  modalDialog: modalDialogReducer,
  addCustomerModal: addCustomerModalReducer,
});

export const store = configureStore({
  reducer: Reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});
